// Product Showcase Section JS
window.initProductShowcaseSection = function(sectionId) {
  const showcaseRoots = document.querySelectorAll(`[data-parts-showcase-section="${sectionId}"]`);
  const roots = showcaseRoots.length ? showcaseRoots : [document];

  roots.forEach(root => {
    const productsGrid = root.querySelector(`.parts-products-grid-${sectionId}`);
    const navItems = root.querySelectorAll(`.parts-nav-item-${sectionId}`);

    // If the section isn't present on the page, bail safely
    if (!productsGrid || !navItems.length) return;
  
    // Helper function to generate badge based on product tags
    function generateBadge(tags) {
      if (!tags || !Array.isArray(tags)) return '';
      
      const tagsLower = tags.map(tag => tag.toLowerCase());
      if (tagsLower.includes('new')) {
        return `<span class="parts-product-badge-${sectionId} parts-badge-new-${sectionId}">New</span>`;
      } else if (tagsLower.includes('hot')) {
        return `<span class="parts-product-badge-${sectionId} parts-badge-hot-${sectionId}">Hot</span>`;
      }
      return '';
    }

    // Function to create product card HTML
    function createProductCard(product) {
      // Generate image HTML
      const imageHtml = product.featured_image 
        ? `<img src="${product.featured_image}" alt="${product.featured_image_alt}" class="parts-product-image-${sectionId}" loading="lazy">`
        : `<div class="parts-product-image-placeholder-${sectionId}"><span>No image available</span></div>`;
      
      // Generate badge HTML (New/Hot)
      const badge = generateBadge(product.tags);
      
      // Generate sold out badge
      const soldOutBadge = !product.available 
        ? `<div class="parts-sold-out-badge-${sectionId}">sold out</div>` 
        : '';
      
      return `
        <div class="parts-product-card-${sectionId}">
          <a href="${product.url}" class="parts-product-image-wrapper-${sectionId}">
            ${imageHtml}
            ${soldOutBadge}
          </a>
          <div class="parts-product-info-${sectionId}">
            <div class="parts-product-title-row-${sectionId}">
              <h3 class="parts-product-title-${sectionId}">${product.title}</h3>
              ${badge}
            </div>
            <div class="parts-product-actions-${sectionId}">
              <a href="${product.url}" class="parts-product-link-${sectionId}">View details ></a>
            </div>
          </div>
        </div>
      `;
    }
  
    // Function to load products for a collection
    function loadCollection(collectionHandle, blockId) {
      productsGrid.classList.add('loading');
      const collectionDataScript = document.getElementById(`parts-collection-data-${blockId}-${sectionId}`);
      if (!collectionDataScript) {
        console.error('Collection data not found for:', collectionHandle);
        showNoCollectionMessage();
        return;
      }
      try {
        const collectionData = JSON.parse(collectionDataScript.textContent);
        setTimeout(() => {
          productsGrid.classList.remove('loading');
          productsGrid.innerHTML = '';
          const allEquipmentLink = document.getElementById(`parts-all-equipment-link-${sectionId}`);
          if (allEquipmentLink && collectionData.collection_url) {
            allEquipmentLink.href = collectionData.collection_url;
          }
          if (collectionData.products && collectionData.products.length > 0) {
            collectionData.products.forEach(product => {
              productsGrid.innerHTML += createProductCard(product);
            });
            if (typeof gtag !== 'undefined') {
              gtag('event', 'collection_switch', {
                'event_category': 'navigation',
                'event_label': collectionData.collection_title,
                'section_id': sectionId
              });
            }
          } else {
            showNoProductsMessage(collectionData.collection_title);
          }
        }, 300);
      } catch (error) {
        console.error('Error parsing collection data:', error);
        showNoCollectionMessage();
      }
    }
  
    function showNoCollectionMessage() {
      productsGrid.classList.remove('loading');
      productsGrid.innerHTML = `<div class="parts-no-collection-message-${sectionId}">Please select a product collection in the theme settings.</div>`;
    }
  
    function showNoProductsMessage(collectionTitle) {
      productsGrid.classList.remove('loading');
      productsGrid.innerHTML = `<div class="parts-no-collection-message-${sectionId}">Product Series"${collectionTitle}"No products available.</div>`;
    }
  
    navItems.forEach(item => {
      item.addEventListener('click', function(e) {
        if (!this.dataset.collection || this.getAttribute('href') === '#') {
          e.preventDefault();
        }
      });

      item.addEventListener('mouseenter', function(e) {
        const collectionHandle = this.dataset.collection;
        const blockId = this.dataset.blockId;
        if (!collectionHandle) {
          console.warn('No collection handle found for navigation item');
          return;
        }
        navItems.forEach(nav => {
          nav.classList.remove('active');
          // nav.classList.remove('loading');
        });
        this.classList.add('active');
        loadCollection(collectionHandle, blockId);
        // setTimeout(() => {
        //   this.classList.remove('loading');
        // }, 500);
      });
    });
  
    // Load first collection on page load
    const firstNavItem = navItems[0];
    if (firstNavItem) {
      const firstCollectionHandle = firstNavItem.dataset.collection;
      const firstBlockId = firstNavItem.dataset.blockId;
      if (firstCollectionHandle) {
        loadCollection(firstCollectionHandle, firstBlockId);
        const collectionDataScript = document.getElementById(`parts-collection-data-${firstBlockId}-${sectionId}`);
        if (collectionDataScript) {
          try {
            const collectionData = JSON.parse(collectionDataScript.textContent);
            const allEquipmentLink = document.getElementById(`parts-all-equipment-link-${sectionId}`);
            if (allEquipmentLink && collectionData.collection_url) {
              allEquipmentLink.href = collectionData.collection_url;
            }
          } catch (e) {}
        }
      } else {
        showNoCollectionMessage();
      }
    }
  
    // Product card click tracking
    document.addEventListener('click', function(e) {
      const productWrapper = e.target.closest(`.parts-product-wrapper-${sectionId}`);
      if (productWrapper) {
        const productTitle = productWrapper.querySelector(`.parts-product-title-${sectionId}`)?.textContent || '';
        if (typeof gtag !== 'undefined') {
          gtag('event', 'product_click', {
            'event_category': 'engagement',
            'event_label': productTitle,
            'section_id': sectionId
          });
        }
      }
    });
  });
}; 
